// extracted by mini-css-extract-plugin
module.exports = {"root":"image-logo-module--root--2Ftwt","logo":"image-logo-module--logo--1uVce"};